import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.clients.length ? _c('div', {
    staticClass: "d-flex justify-space-between align-center signin__options"
  }, [_c('h3', {
    staticClass: "font-weight-bold",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.federatedLoginText')))]), _c('div', {
    staticClass: "d-flex"
  }, _vm._l(_vm.clients, function (item, i) {
    return _c('div', {
      key: i
    }, [_vm._t("singleButton", function () {
      return [item.redirectURI && item.logo ? _c(VBtn, {
        staticClass: "signin__options--btn ml-3",
        attrs: {
          "title": item.name,
          "fab": "",
          "text": "",
          "href": item.redirectURI
        }
      }, [_c('img', {
        staticClass: "image-upload-img",
        attrs: {
          "src": item.logo,
          "alt": item.name,
          "width": "40"
        }
      })]) : _c(VBtn, {
        staticClass: "signin__options--btn ml-3",
        attrs: {
          "title": item.name,
          "href": item.redirectURI
        }
      }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])];
    }, {
      "button": item
    })], 2);
  }), 0), _c(VCheckbox, {
    staticClass: "mt-2 mb-1 ml-2",
    staticStyle: {
      "font-weight": "600"
    },
    attrs: {
      "dark": true,
      "outlined": "",
      "hide-details": "",
      "label": _vm.$i18n_t('Common.federatedLoginRemeberMe')
    },
    model: {
      value: _vm.rememberUser,
      callback: function ($$v) {
        _vm.rememberUser = $$v;
      },
      expression: "rememberUser"
    }
  })], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };